import {Injectable} from '@angular/core';
import {AuthenticationService} from './authentication.service';
import {User} from '../_models/user.model';

declare var dataLayer: any;
declare var icogz: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  currentUser: User;

  constructor(
    private authenticateService: AuthenticationService,
  ) {
    this.authenticateService.currentUser.subscribe(x => {
      this.currentUser = x;
    });
  }

  productClick(product: any, clickedFrom: string): void {
    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    console.log('Pushing Click Analytics');
    icogz.trackEvent(JSON.stringify({
      name: product.details.title,
      id: product.details.id,
      price: product.details.sale_price,
      brand: product.merchants.merchant_name,
      category: product.details.category_name,
    }), 'product_view');
    dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: {list: clickedFrom},
          products: [{
            name: product.details.title,
            id: product.details.id,
            price: product.details.sale_price,
            brand: product.merchants.merchant_name,
            category: product.details.category_name,
          }]
        }
      }
    });
  }

  pageImpression(product: any): void {

    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    console.log('Pushing Page Impressions');
    dataLayer.push({
      ecommerce: {
        detail: {
          actionField: {},
          products: [{
            name: product.details.title,
            id: product.details.id,
            price: product.details.sale_price,
            brand: product.merchants.merchant_name,
            category: product.details.category_name,
          }]
        }
      }
    });
  }

  addToCart(product: any, deal: any = ''): void {
    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    if (product.details.product_type === 'STANDARD') {
      console.log('Pushing Add to Cart');

      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'INR',
          add: {
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: product.details.sale_price,
              brand: product.merchants.merchant_name,
              category: product.details.category_name,
              variant: deal.deal_title,
              quantity: deal.quantity,
            }]
          }
        }
      });
    } else {
      console.log('Pushing Add to Cart');
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'INR',
          add: {
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: product.details.sale_price,
              brand: product.merchants.merchant_name,
              category: product.details.category_name,
            }]
          }
        }
      });
    }
  }

  checkOut(product: any, deal: any): void {
    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    if (product.details.product_type === 'STANDARD') {
      console.log('Pushing Checkout');
      dataLayer.push({
        event: 'checkout',
        ecommerce: {
          actionField: {step: 1},
          checkout: {
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: deal.deal_sale_price,
              brand: product.merchants.merchant_name,
              variant: deal.deal_title,
              quantity: deal.quantity,
              category: product.details.category_name,
            }]
          }
        }
      });
    } else {
      console.log('Pushing Add to Cart');
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'INR',
          add: {
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: product.details.sale_price,
              brand: product.merchants.merchant_name,
              category: product.details.category_name,
            }]
          }
        }
      });
    }
  }

  purchaseComplete(product: any, deal: any, orderResponse: any, couponCode = ''): void {
    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.

    icogz.trackEvent(JSON.stringify({
      user_id: this.currentUser.id,
      order_id: orderResponse.order.order_id,
      revenue: orderResponse.product.price,
      product_name: product.details.title,
      product_id: product.details.id,
      product_price: deal.deal_sale_price,
      product_brand: product.merchants.merchant_name,
      product_variant: deal.deal_title,
      product_quantity: deal.quantity,
      product_category: product.details.category_name,
    }), 'purchase_complete');

    if (product.details.product_type === 'STANDARD') {
      console.log('Pushing - Purchase Complete');
      dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: orderResponse.order.order_id,                         // Transaction ID. Required for purchases and refunds.
              affiliation: 'Online Store',
              revenue: orderResponse.product.price,                     // Total transaction value (incl. tax and shipping)
              tax: '0',
              shipping: '0',
              coupon: couponCode
            },
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: deal.deal_sale_price,
              brand: product.merchants.merchant_name,
              variant: deal.deal_title,
              quantity: deal.quantity,
              category: product.details.category_name,
            }]
          }
        }
      });
    } else {
      dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: orderResponse.order.order_id,                         // Transaction ID. Required for purchases and refunds.
              affiliation: 'Online Store',
              revenue: orderResponse.product.price,                     // Total transaction value (incl. tax and shipping)
              tax: '0',
              shipping: '0',
              coupon: couponCode
            },
            products: [{
              name: product.details.title,
              id: product.details.id,
              price: deal.deal_sale_price,
              brand: product.merchants.merchant_name,
              category: product.details.category_name,
            }]
          }
        }
      });
    }
  }
}
